import axiosClient from "./axiosClient";

const taxSettingsApi = {
  getAllRevenueGroup: () => {
    return axiosClient.get("/tax_settings/get-all-revenue-group", {
      withCredentials: true,
    });
  },
  getAllBusinessType: () => {
    return axiosClient.get("/tax_settings/get-all-business-type", {
      withCredentials: true,
    });
  },
  getTaxCalculation: (type) => {
    return axiosClient.get(`/tax_settings/get-tax-calculation-method/${type}`, {
      withCredentials: true,
    });
  },
  getTaxSetting: (customerId) => {
    return axiosClient.get(`/tax_settings/get-tax-setting/${customerId}`, {
      withCredentials: true,
    });
  },
  saveTaxSetting: (
    customerId,
    taxCalculationMethod,
    revenueGroup,
    determineCost,
    industryId,
  ) => {
    return axiosClient.post(
      `/tax_settings/save-tax-setting`,
      {
        customerId: customerId,
        taxCalculationMethod: taxCalculationMethod,
        revenueGroup: revenueGroup,
        determineCost: determineCost,
        industryId: industryId,
      },
      {
        withCredentials: true,
      },
    );
  },
};
export default taxSettingsApi;
